import { render, staticRenderFns } from "./larChart.vue?vue&type=template&id=65643e66&scoped=true&"
import script from "./larChart.vue?vue&type=script&lang=js&"
export * from "./larChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65643e66",
  null
  
)

export default component.exports